<template>
  <div id="container">
    <iframe allowfullscreen @load="iframeLoaded" src="https://game-launcher-stage1.isoftbet.com/1796/200066?lang=en&cur=MXN&mode=0&user=mmgaptest&uid=FA256A55FE358A8C13EE2DECB572217C&token=b2a6aa9a-4cea-410b-8842-3433b40ca241"></iframe>
<!--    <iframe src="https://game-launcher-stage1.isoftbet.com/1796/200975?lang=es&cur=MXN&mode=0"></iframe>-->

<!--    https://game-launcher-stage1.isoftbet.com/1796/200066?lang=es&cur=MXN&mode=0&user=mmgaptest&uid=FA256A55FE358A8C13EE2DECB572217C&token=b2a6aa9a-4cea-410b-8842-3433b40ca241-->
    <div>
      <button class="button">Click me to fullscreen the iframe</button>
    </div>
    <div class="info">You can check keydown event listener when the browser are in fullscreen and press F11 and ESC by console log on developer tools</div
    <div class="error"></div>
  </div>
</template>
<script>
export default {
  name: 'casinoTestComponent',
  created () {},
  destroyed () {},
  mounted () {
    this.initListener()
  },
  data () {
    return {}
  },
  methods: {
    initListener () {
      let button = document.querySelector('#container .button')
      button.addEventListener('click', this.fullscreen)
      // when you are in fullscreen, ESC and F11 may not be trigger by keydown listener.
      // so don't use it to detect exit fullscreen
      document.addEventListener('keydown', function (e) {
        console.log('key press')
      })
      // detect enter or exit fullscreen mode
      document.addEventListener('webkitfullscreenchange', this.fullscreenChange)
      document.addEventListener('mozfullscreenchange', this.fullscreenChange)
      document.addEventListener('fullscreenchange', this.fullscreenChange)
      document.addEventListener('MSFullscreenChange', this.fullscreenChange)
    },
    fullscreen () {
  // check if fullscreen mode is available
      if (document.fullscreenEnabled ||
    document.webkitFullscreenEnabled ||
    document.mozFullScreenEnabled ||
    document.msFullscreenEnabled) {
    // which element will be fullscreen
        let iframe = document.querySelector('#container iframe')
    // Do fullscreen
        if (iframe.requestFullscreen) {
          iframe.requestFullscreen()
        } else if (iframe.webkitRequestFullscreen) {
          iframe.webkitRequestFullscreen()
        } else if (iframe.mozRequestFullScreen) {
          iframe.mozRequestFullScreen()
        } else if (iframe.msRequestFullscreen) {
          iframe.msRequestFullscreen()
        }
      } else {
        document.querySelector('.error').innerHTML = 'Your browser is not supported'
      }
    },
    fullscreenChange () {
      if (document.fullscreenEnabled ||
    document.webkitIsFullScreen ||
    document.mozFullScreen ||
    document.msFullscreenElement) {
        console.log('CASINO enter fullscreen')
      } else {
        console.log('CASINO exit fullscreen')
      }
  // force to reload iframe once to prevent the iframe source didn't care about trying to resize the window
  // comment this line and you will see
      let iframe = document.querySelector('iframe')
      iframe.src = iframe.src
    },
    iframeLoaded () {
      setTimeout(() => {
        console.log('CASINO5 iframe loaded')
      }, 100)
    }
  }
}
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/components/igaming/partials/casinoTestComponent.vue